import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
} from "react";
import { Container } from "@pixi/react";
import { useDimensions } from "../../../Contexts/DimensionsContext";
import GlobalLineWinTextController from "./GlobalLineWinTextController";
import { safeInit } from "../../../utilities";

const GlobalLineWinText = forwardRef((props, ref) => {
  const containerRef = useRef(null);
  const controllerRef = useRef(null);
  const { symbolWidth, symbolHeight } = useDimensions();

  // Initialize controller when container is ready (after render completes)
  useEffect(() => {
    if (containerRef.current && !controllerRef.current) {
      safeInit(() => {
        controllerRef.current = new GlobalLineWinTextController(
          containerRef.current,
          symbolWidth,
          symbolHeight
        );
      });
    }

    return () => {
      if (controllerRef.current) {
        controllerRef.current.cleanup();
        controllerRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle dimension changes
  useEffect(() => {
    if (controllerRef.current && symbolWidth && symbolHeight) {
      controllerRef.current.updateDimensions(symbolWidth, symbolHeight);
    }
  }, [symbolWidth, symbolHeight]);

  useImperativeHandle(ref, () => ({
    showWinAmount: (amount) => {
      controllerRef.current?.showWinAmount(amount);
    },
    hide: () => {
      controllerRef.current?.hide();
    },
  }));

  // Position at the bottom of the 3rd symbol (bottom symbol, index 2 of 0,1,2)
  const mainY = symbolHeight * 2.5;

  return (
    <Container
      ref={containerRef}
      y={Math.round(mainY)}
      x={0}
      zIndex={12}
      sortableChildren
      name="global_line_win_text"
    />
  );
});

export default GlobalLineWinText;
